import { render, staticRenderFns } from "./edit.vue.html?vue&type=template&id=1c12f93c"
import script from "./edit.controller?vue&type=script&lang=js&external"
export * from "./edit.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports